if (!customElements.get('hero-banner')) {
  const FeatureHighlight = customElements.get('feature-highlight');

  class HeroBanner extends FeatureHighlight {
    connectedCallback() {
      super.connectedCallback();

      const hoverable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      this.classList.toggle('hero-banner--hoverable', hoverable);

      if (!hoverable) {
        this.onImageTap = this.onImageTap.bind(this);
        this.imageWrap = this.querySelector('.hero-banner__image-wrap');
        if (this.imageWrap) this.imageWrap.addEventListener('click', this.onImageTap);
      }
    }

    disconnectedCallback() {
      super.disconnectedCallback();
      if (this.imageWrap) this.imageWrap.removeEventListener('click', this.onImageTap);
    }

    onImageTap() {
      this.classList.toggle('is-active');
    }
  }

  customElements.define('hero-banner', HeroBanner);
}
